import ServiceEventTracking from 'services/service.event-tracking';

type SendOfferViewedEntirelyEventArgs = {
  companyName: string;
  offerCode: string;
  locale?: string;
};

export const sendOfferViewedEntirelyEvent = ({
  companyName,
  offerCode,
  locale
}: SendOfferViewedEntirelyEventArgs): void => {
  const offerURL = window.location.href;
  const urlParams = new URLSearchParams(window.location.search);

  ServiceEventTracking.track({
    type: 'Offers - Offer Viewed Entirely',
    properties: {
      offerCompany: companyName,
      offerName: offerCode,
      offerURL,
      urlParams: urlParams.toString(),
      pageLanguage: locale,
      utmCampaign: urlParams.get('utm_campaign') || undefined,
      utmContent: urlParams.get('utm_content') || undefined,
      utmId: urlParams.get('utm_id') || undefined,
      utmMedium: urlParams.get('utm_medium') || undefined,
      utmSource: urlParams.get('utm_source') || undefined
    }
  });
};
